<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal scrollable size="xl" :visible="modal && modal.show" @hidden="onHidden" :content-in-form="false"
                   v-if="modal && modal.object" @show="onShow" :body-class="modal.source === 'reports' ? 'p-0' : ''"
                   :title="$t('Send Report')" :hide-footer="modal.source === 'requests'" modal-class="mobile-full-screen">
      <div class="modal-height">
        <condition-reports-table v-if="modal.source === 'requests'"
            :exclude-columns="['status', 'publish_on_website', 'created_at', 'created_by', 'released_by']"
            :hide-actions="hideActions" hide-top-actions :filter-toggle-string="''" small-row-actions
            :send-override="send"
            :source="'send_modal'" :extra-filters="{status: 'released', inventory_uuid: modal.object.inventory_uuid}">
        </condition-reports-table>
        <div v-else-if="modal.source === 'reports'" >
          <b-tabs v-model="activeTab" small card @changed="checkSubmitButtonState">
            <b-tab :title="$t('Pending Requests')"  active>
              <condition-report-requests-table
                  :exclude-columns="['rejected_at', 'rejected_by', 'created_at', 'created_by', 'sent_by', 'sent_at', 'condition_report', 'inventory', 'actions']"
                  :filter-toggle-string="''" hide-top-actions @selectedItemsChange="selectedItemsChange">
              </condition-report-requests-table>
            </b-tab>
            <b-tab :title="$t('All Customers')">
              <customer-table :exclude-columns="['activity', 'interest_categories', 'address', 'phone',
              'account_managers', 'interest_categories', 'optin']"
              :exclude-search-fields="['category_uuids', 'activityDateRange', 'interest_category_uuids',
               'phone', 'address_info', 'account_managers', 'tags', 'optin', 'is_vendor', 'gender', 'account_manager', 'accounting_code']"
              :selectable="true" @selectedItemsChange="onSelectedCustomerChange" :with-initial-data="false"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <template v-slot:modal-footer>
        <cancel-button @click="onHidden">
          {{ $t('Cancel') }}
        </cancel-button>
        <submit-button @click="onSubmit()" :disabled="disableSubmitButton">
          {{ $t('Save') }}
        </submit-button>
      </template>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import ConditionReportsTable from "@/modules/condition-reports/ConditionReportsTable.vue";
  import {ACTION_EDIT_CONDITION_REPORT, ACTION_REMOVE_CONDITION_REPORT} from "@/modules/constants";
  import ConditionReportRequestsTable from "@/modules/condition-report-requests/ConditionReportRequestsTable.vue";
  import TabLayout from "@/core/components/layout/DefaultLayout/TabLayout.vue";
  import CustomerTable from "@/modules/customer/CustomerTable.vue";
  import CancelButton from "@/core/components/common/CancelButton.vue";
  import SubmitButton from "@/core/components/common/SubmitButton.vue";

  const {mapState, mapActions} = createNamespacedHelpers('conditionReportRequests');
  const {mapActions: mapActionsReports} = createNamespacedHelpers('conditionReports');
  const {mapActions: mapActionsCustomers} = createNamespacedHelpers('customer');
  export default {
    name: "ConditionReportSendModal",
    components: {
      SubmitButton,
      CancelButton,
      CustomerTable, TabLayout, ConditionReportRequestsTable, ConditionReportsTable, ArtisioModal},
    data() {
      return {
        activeTab: 0,
        disableSubmitButton: true,
        tabs: {
          condition_request: 0,
          customers: 1
        }
      }
    },
    computed: {
      ...mapState({
        modal: state => state.sendModal,
      }),
      hideActions() {
        return [ACTION_EDIT_CONDITION_REPORT, ACTION_REMOVE_CONDITION_REPORT, 'use_as_draft', 'view_activity_log']
      },
    },
    methods: {
      ...mapActions(['hideSendModal', 'getTableData', 'updateTableSource']),
      ...mapActionsReports(['updateConditionReportPartially']),
      ...mapActionsCustomers({
        updateCustomerTableSource: 'updateTableSource'
      }),
      onHidden() {
        this.hideSendModal();
      },
      async send(report) {
        const emails = this.modal.object.items.map(i => i.customer ? i.customer.email : i.email).join(', ');
        const title = `[${report.version}${report.version_suffix}] ${report.title}`;
        const confirmed = await this.$confirm(this.$i18n.t("Are you sure you want to send {title} to {emails}?", {
          title,
          emails
        }));
        if (!confirmed) {
          return;
        }
        const data = {uuid: report.uuid};
        if (this.modal.source === 'requests') {
          data.send_to = this.modal.object.request_uuids;
        } else {
          if (this.activeTab === this.tabs.condition_request) {
            data.send_to = this.modal.object.request_uuids;
          } else if (this.activeTab === this.tabs.customers) {
            data.customer_uuids = this.modal.object.customer_uuids;
          }
        }
        const response = await this.updateConditionReportPartially(data);
        if (response.success) {
          this.$toast('success', this.$i18n.t('Report was successfully sent.'))
          if (this.modal.source === 'requests') {
            this.getTableData();
          }
          this.onHidden();
        } else {
          this.$errorDialog(response.body.non_field_errors ? response.body.non_field_errors[0] : 'Error in sending requests.');
        }
      },
      onShow() {
        if (this.modal.source === 'reports') {
          this.updateTableSource({
            source: 'send_modal',
            extraFilters: {status: 'pending', inventory_uuid: this.modal.object.inventory_uuid}
          });
          this.updateCustomerTableSource({source: 'conditionReports'})
        }
      },
      onSubmit() {
        this.send(this.modal.object.report);
      },
      selectedItemsChange(selectedItems) {
        this.modal.object.request_uuids = Array.from(selectedItems).map(i => i.uuid);
        this.modal.object.items = Array.from(selectedItems);
        this.checkSubmitButtonState();
      },
      onSelectedCustomerChange(selectedItems) {
        this.modal.object.customer_uuids = Array.from(selectedItems).map(i => i.uuid);
        this.modal.object.items = Array.from(selectedItems);
        this.checkSubmitButtonState();
      },
      checkSubmitButtonState() {
        if (this.activeTab === this.tabs.condition_request) {
          this.disableSubmitButton = !this.modal.object.request_uuids || !this.modal.object.request_uuids.length;
        } else if (this.activeTab === this.tabs.customers) {
          this.disableSubmitButton = !this.modal.object.customer_uuids || !this.modal.object.customer_uuids.length;
        } else {
          this.disableSubmitButton = true;
        }
      }
    },
  }
</script>

<style scoped>
  .modal-height {
    height: 60em
  }
</style>
